import moment from "moment";

// Calculate minimum allowed date for privacy (oldest of last January 1st or last September 1st)
export const getMinAllowedDate = () => {
    const now = moment();
    const lastJanuary = moment().startOf('year');
    const lastSeptember = moment().set({ month: 8, date: 1 });
    
    // If we haven't reached September yet this year, use last year's September
    if (now.isBefore(lastSeptember)) {
        lastSeptember.subtract(1, 'year');
    }
    
    // Return the oldest (earlier) date
    return lastJanuary.isBefore(lastSeptember) 
        ? lastJanuary.format('YYYY-MM-DD') 
        : lastSeptember.format('YYYY-MM-DD');
};

const quickButtonStyle = {
    padding: '6px 12px',
    fontSize: 13,
    fontWeight: 500,
    background: '#fff',
    border: '1px solid #e2e8f0',
    borderRadius: 6,
    color: '#475569',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    whiteSpace: 'nowrap'
};

const inputStyle = {
    padding: '10px 12px',
    fontSize: 14,
    border: '1px solid #e2e8f0',
    borderRadius: 6,
    color: '#1e293b',
    background: '#fff',
    outline: 'none',
    fontFamily: 'inherit'
};

const labelStyle = {
    fontSize: 12,
    fontWeight: 600,
    color: '#64748b',
    marginBottom: 6,
    textTransform: 'uppercase',
    letterSpacing: '0.04em'
};

function StatsDateSelector({
    start_date,
    setStart_date,
    end_date,
    setEnd_date,
    minDate
}) {
    const now = moment();
    const september = moment().set({ 'month': 8, 'date': 1 });
    const septemberYear = now.isBefore(september) ? now.year() - 1 : now.year();
    
    // Handle date changes with minDate enforcement
    const handleStartDateChange = (newDate) => {
        if (minDate && moment(newDate).isBefore(minDate)) {
            setStart_date(minDate);
        } else {
            setStart_date(newDate);
        }
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: 32,
            padding: '20px 24px',
            background: '#f8fafc',
            borderRadius: 8,
            border: '1px solid #e2e8f0'
        }}>
            <div style={{ display: 'flex', flexDirection: 'column', minWidth: 200 }}>
                <label htmlFor="start_date" style={labelStyle}>Data d'inici</label>
                <input
                    type="date"
                    id="start_date"
                    name="start_date"
                    value={start_date}
                    min={minDate}
                    onChange={e => handleStartDateChange(e.target.value)}
                    style={inputStyle}
                />
                <div style={{ display: 'flex', flexDirection: 'row', gap: 6, marginTop: 10, flexWrap: 'wrap' }}>
                    <button
                        onClick={() => handleStartDateChange(moment().startOf('year').format('YYYY-MM-DD'))}
                        style={quickButtonStyle}
                    >
                        01/01/{String(now.year()).slice(-2)}
                    </button>
                    <button
                        onClick={() => {
                            const now = moment();
                            const september = moment().set({ 'month': 8, 'date': 1 });
                            if (now.isBefore(september)) {
                                handleStartDateChange(september.subtract(1, 'year').format('YYYY-MM-DD'));
                            } else {
                                handleStartDateChange(september.format('YYYY-MM-DD'));
                            }
                        }}
                        style={quickButtonStyle}
                    >
                        01/09/{String(septemberYear).slice(-2)}
                    </button>
                    <button
                        onClick={() => handleStartDateChange(moment().subtract(1, 'month').format('YYYY-MM-DD'))}
                        style={quickButtonStyle}
                    >
                        −1 mes
                    </button>
                    <button
                        onClick={() => handleStartDateChange(moment().format('YYYY-MM-DD'))}
                        style={quickButtonStyle}
                    >
                        Avui
                    </button>
                </div>
            </div>

            <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                color: '#94a3b8',
                fontSize: 20,
                marginTop: 20
            }}>
                →
            </div>
            
            <div style={{ display: 'flex', flexDirection: 'column', minWidth: 200 }}>
                <label htmlFor="end_date" style={labelStyle}>Data final</label>
                <input
                    type="date"
                    id="end_date"
                    name="end_date"
                    value={end_date}
                    onChange={e => setEnd_date(e.target.value)}
                    style={inputStyle}
                />
                <div style={{ display: 'flex', flexDirection: 'row', gap: 6, marginTop: 10, flexWrap: 'wrap' }}>
                    <button
                        onClick={() => setEnd_date(moment().format('YYYY-MM-DD'))}
                        style={quickButtonStyle}
                    >
                        Avui
                    </button>
                    <button
                        onClick={() => setEnd_date(moment().add(1, 'month').format('YYYY-MM-DD'))}
                        style={quickButtonStyle}
                    >
                        +1 mes
                    </button>
                    <button
                        onClick={() => setEnd_date(moment().endOf('year').format('YYYY-MM-DD'))}
                        style={quickButtonStyle}
                    >
                        31/12/{String(now.year()).slice(-2)}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default StatsDateSelector;

